import service from '@/middleware'

const eventApi = {
    /**
     * Para cargar los selectores de eventos en el ABM de Empresas
     */
    async findAllForSelector(enterpriseId) {
        let response
        if (enterpriseId) {
            response = await service.http.get(`/api/events/all-for-selector`, { params: { enterpriseId } })
        } else {
            response = await service.http.get(`/api/events/all-for-selector`)
        }
        return response
    },
    /**
     * Datos para la tabla del ABM de tipos de eventos
     * @param {*} pageSize
     * @param {*} pageNumber
     */
    async findAllEventType(pageSize, pageNumber) {
        const url = pageSize != null && pageNumber != null
            ? `/api/events/type/abm-all?pageSize=${pageSize}&pageNumber=${pageNumber}`
            : `/api/events/type/abm-all`
        const response = await service.http.get(url)
        return response
    },
    /**
     * Total de tipos de eventos para el paginador de la tabla del ABM
     */
    async getEventTypeTotal () {
        const result = await service.http.get(`/api/events/type/total`)
        return result
    },
    /**
     * Para obtener un tipo de evento con el id enviado como param
     * @param {*} eventTypeId
     */
    async findOneEventType (eventTypeId) {
        const result = await service.http.get(`/api/events/type/one-by-id/${eventTypeId}`)
        return result
    },
    /**
     * Para crear un nuevo tipo de evento
     * @param {*} eventTypeDto
     */
    async createEventType (eventTypeDto) {
        const result = await service.http.post(`/api/events/type/create`, eventTypeDto)
        return result
    },
    /**
     * Para actualizar un tipo de evento
     * @param {*} eventTypeDto
     */
    async updateEventType (eventTypeDto) {
        const result = await service.http.put(`/api/events/type/update`, eventTypeDto)
        return result
    },
    /**
     * Para eliminar un tipo de evento
     * @param {*} id
     */
    async deleteOneEventType (id) {
        const result = await service.http.delete(`/api/events/type/${id}`)
        return result
    },
    /**
     * Eliminación múltiple
     * @param {*} ids 
     */
    async deleteManyEventType (ids) {
        const result = await service.http.put(`/api/events/type/multiple-delete`, ids)
        return result
    },
    /**
     * Validación de una traducción del nombre
     * @param {*} locale
     * @param {*} translation
     */
    async validateTranslation (locale, translation, id) {
        let result
        if (id) {
            result = await service.http.get(`/api/events/type/validate-translation?locale=${locale}&translation=${translation}&id=${id}`)
        } else {
            result = await service.http.get(`/api/events/type/validate-translation?locale=${locale}&translation=${translation}`)
        }
        return result
    }
}

export default eventApi
